export default __webpack_public_path__ + "static/media/messageIcon.d2412212.svg";